import constants from '@src/constants'

// **  Initial State
const initialState = {
  userData: {},
  // The real logged-in user's id, set only on login / genuine self-fetch.
  // Never overwritten when switching to another manager's context.
  loggedInUserId: null
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        loggedInUserId: action.data.admin_register_master_id,
        userData: {
          ...action.data,
          is_admin: action.data.role === constants.roles.admin,
          is_manager: action.data.role === constants.roles.manager,
          is_asst_manager: action.data.role === constants.roles.asst_manager
        }
        // [action.config.storageTokenKeyName]: action[action.config.storageTokenKeyName],
        // [action.config.storageRefreshTokenKeyName]: action[action.config.storageRefreshTokenKeyName]
      }
    case 'SET_UP_DATA':
      return {
        ...state,
        loggedInUserId: action.data.admin_register_master_id,
        userData: {
          ...action.data,
          is_admin: action.data.role === constants.roles.admin,
          is_manager: action.data.role === constants.roles.manager,
          is_asst_manager: action.data.role === constants.roles.asst_manager
        }
      }
    // Dispatched when switching to another manager's context (see getAuthSubManager /
    // getAuthParentManager). Updates the displayed/acting userData but must NOT touch
    // loggedInUserId, which always identifies the actual logged-in user.
    case 'SET_ACTING_MANAGER_DATA':
      return {
        ...state,
        userData: {
          ...action.data,
          is_admin: action.data.role === constants.roles.admin,
          is_manager: action.data.role === constants.roles.manager,
          is_asst_manager: action.data.role === constants.roles.asst_manager
        }
      }
    case 'LOGOUT':
      // const obj = { ...action }
      // delete obj.type
      // return { ...state, userData: {}, ...obj }
      return initialState
    default:
      return state
  }
}

export default authReducer
